import React from 'react';
import { Button, Flex } from '../../../../flayr-components';
import SingularOrPluralText from '../../../../lib/SingularOrPluralText/SingularOrPluralText';
import { IFormSettings } from '../../../../types/formSettings';
import SearchWizardServiceSelect from '../../../SearchWizardServiceSelect/SearchWizardServiceSelect';

interface IServicesStepProps {
  formSettings?: IFormSettings;
  services?: string[];
  onChange?: (e: any) => void;
}

const ServicesStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<IServicesStepProps>>> = ({
  services = [],
  onChange,
  formSettings,
}) => {
  return (
    <div className="pb-8">
      <SearchWizardServiceSelect
        addBtnPlacement="bottom-right"
        availableServices={formSettings?.serviceTypes || []}
        services={services}
        onSelect={onChange}
        renderAddBtn={({ onAdd }) => (
          <Flex x="between" className="px-4 pt-5 border-t" wrap>
            <span className="mb-4 font-medium">
              {services?.length}{' '}
              <SingularOrPluralText
                number={services.length}
                singular="person"
                plural="people"
              />
            </span>

            <Button className="mb-4 uppercase" color="dark" onClick={onAdd}>
              Add another person
            </Button>
          </Flex>
        )}
      />
    </div>
  );
};
export default ServicesStep;
